import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useClient } from "../context/ClientContext.tsx";

export default function SelectProduct() {
    const navigate = useNavigate();
    const { subscriptionActive, organization } = useClient();

    useEffect(() => {
        // If user already has a subscription, just send them home
        if (subscriptionActive) {
            navigate("/");
            return;
        }

        // Build checkout URL
        const lsBaseUrl = process.env.REACT_APP_LEMON_SQUEEZY_CHECKOUT_URL;

        const url =
            `${lsBaseUrl}` +
            `?checkout[custom][ClientCode]=${encodeURIComponent(organization)}` +
            `&checkout[success_url]=https://zippyq.app/` +
            `&checkout[cancel_url]=https://zippyq.app/`;

        // Open checkout in a new tab
        window.open(url, "_blank", "noopener,noreferrer");

        // Immediately return user to the root page
        navigate("/");

    }, [subscriptionActive, organization, navigate]);

    // Render nothing — this page is just a redirect bridge
    return null;
}